var $ = jQuery.noConflict();

/* Script on ready
------------------------------------------------------------------------------*/
$( document ).ready( function() {

    new WOW().init();

    /* Product Details Page Script */
    $('.product-media--wrapper').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        arrows: false,
        dots: false,
        fade: false,
        asNavFor: '.product-media--thumbs'
    });
    $('.product-media--thumbs').slick({
        arrows: true,
        dots: false,
        fade: false,
        autoplaySpeed: 3000,
        autoplay: true,
        slidesToShow: 3,
        slidesToScroll: 1,  
        centerMode: true,
        centerPadding: 0,
        focusOnSelect: true,      
        asNavFor: '.product-media--wrapper',
        responsive: [
          {
            breakpoint: 993,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 481,
            settings: {
              slidesToShow: 1
            }
          }
        ]
    });
	
    /* Testimonial Script */
   $('.testimonial--part').slick({
       dots: false,
       infinite: true,
       autoplay: true,
       autoplaySpeed: 2000,
       slidesToShow: 1,
       slidesToScroll: 1
    });

    /* FAQ Script */
    $('.accordion--item .accordion--title').click(function() {
        if ($(this).parents('.accordion--item').hasClass('active')) {
            $(this).parents('.accordion--item').removeClass('active')
            $(this).next('.accordion--content').stop(true, false).slideUp();
        } else {
            $('.accordion--item').removeClass('active');
            $('.accordion--content').stop(true, false).slideUp();
            $(this).parents('.accordion--item').addClass('active');
            $(this).next('.accordion--content').stop(true, false).slideDown();
        }
    });

    $('.header--right-side .search--icon a').click(function() {
        $('.modal--window').addClass('search-active');
    });
    $('.modal--close').click(function() {
        $('.modal--window').removeClass('search-active');
    });     
  

});

/* Script on load
------------------------------------------------------------------------------*/
$( window ).on( 'load',function() {
	//page is fully loaded, including all frames, objects and images

});

/* Script on scroll
------------------------------------------------------------------------------*/
$( window ).on( 'scroll',function() {

});

/* Script on resize
------------------------------------------------------------------------------*/
$( window ).on( 'resize',function() {

});

/* Script all functions
------------------------------------------------------------------------------*/